export default __webpack_public_path__ + "static/media/folderprev.55037b5b.svg";